import { LocationService } from '@app/shared/services/utils/location.service';
import { AuthenticationService } from './auth/authentication.service';
import { OrganizationsService } from './organization/organizations.service';
import { SportsService } from '@app/shared/services/utils/sports.service';
import { PermissionsService } from '@app/shared/services/permissions/permissions.service';

export const APP_PROVIDERS = [
	AuthenticationService,
	OrganizationsService,
	LocationService,
	SportsService,
	PermissionsService,
];
